import { ResourceInfoProvider } from '@openx/components-core/lib/Form/context/ResourceInfoContext.tsx';
import type { PackageFormState } from '@openx/types/package.ts';
import type { JSX } from 'react';
import { usePackageContext } from '../../utils/context/PackageContext.tsx';
import { DPackageRates } from './sections/DPackageRates.tsx';
import { MerchandisingDetails } from './sections/MerchandisingDetails.tsx';
import { OnBehalfOf } from './sections/OnBehalfOf.tsx';
import { PackageDetails } from './sections/PackageDetails.tsx';
import { PMPackageRates } from './sections/PMPackageRates.tsx';
import { TargetingCriteria } from './sections/TargetingCriteria.tsx';
import { UsedBySection } from './sections/UsedBy/UsedBySection.tsx';

export type PackageDetailsTabProps = { pckg: PackageFormState };

export const PackageDetailsTab = ({ pckg }: PackageDetailsTabProps): JSX.Element => {
  const { usePackagePermissions, isOa } = usePackageContext();

  const { isInternalUser } = usePackagePermissions();
  const hideSectionForOaExternal = !isOa || isInternalUser;

  return (
    <ResourceInfoProvider name="package">
      {hideSectionForOaExternal && <OnBehalfOf pckg={pckg} />}
      <PackageDetails pckg={pckg} />
      <UsedBySection isCurated={pckg.is_curated} />
      {hideSectionForOaExternal && <MerchandisingDetails pckg={pckg} />}
      <TargetingCriteria pckg={pckg} />
      <DPackageRates pckg={pckg} />
      {hideSectionForOaExternal && <PMPackageRates pckg={pckg} />}
    </ResourceInfoProvider>
  );
};
